import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { IReleaseNote } from '@cbgms/api/modules/releasenotes'
import { generateSubmissionError } from 'utils-support/Form/SubmissionError'
import { getReleaseNote, updateReleaseNote } from 'app-support/releasenotes/state/actions'
import ReleaseNotesForm from './Form'
import { useTranslation } from 'react-i18next'
import { useNotifier } from '@cbgms/base/notifier'

const EditReleaseNotesForm = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const notifier = useNotifier()
  const { UUID } = useParams<{ UUID?: string }>()
  const [initialValues, setInitialValues] = useState<null | IReleaseNote>(null)

  useEffect(() => {
    if (UUID) {
      const asyncFunc = async () => {
        const { Data } = await dispatch(getReleaseNote(UUID))
        setInitialValues(Data)
      }
      asyncFunc()
    }
  }, [UUID])

  const onSubmit = async (values: IReleaseNote) => {
    if (!UUID) return

    try {
      await dispatch(updateReleaseNote(UUID, values))
    } catch (error) {
      throw generateSubmissionError(error)
    }
  }

  const onSubmitAndDone = async (values: IReleaseNote) => {
    await onSubmit(values)
    return '/release-notes'
  }

  const onSubmitSuccess = async () => {
    notifier.success(t('releasenotes.updated_successfully'))
  }

  if (!initialValues) return null

  return (
    <ReleaseNotesForm
      form='releasenotes_edit'
      redirectToURL='/release-notes'
      onSubmit={(values: IReleaseNote) => onSubmit(values)}
      onSubmitAndDone={onSubmitAndDone}
      onSubmitSuccess={onSubmitSuccess}
      initialValues={initialValues}
    />
  )
}

export default EditReleaseNotesForm
